// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608182244/js/" + chunkId + "." + {"44":"ff5fd43a","225":"e62b7a64","481":"549a1102","486":"b06634e3","770":"d6aace29"}[chunkId] + ".0.7185756070372498.chunk.js";
};